import { changeAccessSystem } from '../../../state/advanced/access_system';
import { getBooleanParam } from './abstract_params/boolean_param';

export const AccessSystem = getBooleanParam('Вход', 'По пропускам', 'Свободный', 'enter', changeAccessSystem);
